import useHeroCanvas from "../../hooks/useHeroCanvas";
import useAnchorNav from "../../hooks/useAnchorNav";
import useI18n from "../../i18n/useI18n";

const HomeBannerComponent = () => {
  const canvasRef = useHeroCanvas();
  const navigateToHash = useAnchorNav();
  const { t } = useI18n();

  const titleWords = t("hero.title");
  const stats = t("hero.stats");

  const go = (event, id) => {
    event.preventDefault();
    navigateToHash(id);
  };

  return (
    <section id="home" className="hero">
      <canvas ref={canvasRef} className="hero__canvas" aria-hidden="true" />
      <div className="hero__wash" aria-hidden="true" />
      <div className="hero__grid" aria-hidden="true" />

      <div className="hero__inner">
        <div className="hero__eyebrow eyebrow">
          <span className="eyebrow__label">{t("hero.eyebrow")}</span>
        </div>

        <h1 className="hero__title">
          {Array.isArray(titleWords) &&
            titleWords.map((word, i) => (
              <span
                key={`${word.t}-${i}`}
                className={`hero__word${word.grad ? " hero__word--grad" : ""}`}
                style={{ animationDelay: `${0.15 + i * 0.12}s` }}
              >
                {word.t}
              </span>
            ))}
        </h1>

        <p className="hero__lede">{t("hero.lede")}</p>

        <div className="hero__ctas">
          <a href="#ai" className="hero__cta hero__cta--primary" onClick={(e) => go(e, "ai")}>
            {t("hero.ctaPrimary")}
            <span className="hero__arrow">←</span>
          </a>
          <a href="#projects" className="hero__cta hero__cta--ghost" onClick={(e) => go(e, "projects")}>
            {t("hero.ctaSecondary")}
          </a>
        </div>

        <div className="hero__stats">
          {Array.isArray(stats) &&
            stats.map((label, i) => (
              <div className="hero__stat" key={i}>
                <div className="hero__stat-num">{String(i + 1).padStart(2, "0")}</div>
                <div className="hero__stat-label">{label}</div>
              </div>
            ))}
        </div>
      </div>

      <div className="hero__cue" aria-hidden="true">
        <span className="hero__cue-label">{t("hero.scroll")}</span>
        <span className="hero__cue-line"><span /></span>
      </div>
    </section>
  );
};

export default HomeBannerComponent;
